import { CenteredBox } from '../widgets'

export const SplashScreen = ({ open, zIndex = 5, children, ...props }) => (
  <CenteredBox
    position="absolute"
    fullWidth
    fullHeight
    transition={0.5}
    left={0}
    bottom={open ? 0 : '100%'}
    zIndex={zIndex}
    {...props}
  >
    {children}
  </CenteredBox>
)